import React from 'react';

interface Props {
  color?: string;
}

const LoadingSvg = (props: Props) => {
  const { color = "white" } = props;
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" color="#f00" xmlns="http://www.w3.org/2000/svg">
    <path stroke={color}
          d="M18.85 12C18.85 13.3548 18.4483 14.6792 17.6956 15.8057C16.9429 16.9321 15.8731 17.8101 14.6214 18.3286C13.3697 18.847 11.9924 18.9827 10.6636 18.7184C9.33486 18.4541 8.11431 17.8017 7.15632 16.8437C6.19833 15.8857 5.54593 14.6651 5.28162 13.3364C5.01731 12.0076 5.15296 10.6303 5.67143 9.37862C6.18989 8.12694 7.06787 7.05712 8.19434 6.30443C9.32082 5.55175 10.6452 5.15 12 5.15"
          stroke-opacity="0.6" stroke-width="1.3"/>
  </svg>
};

export default LoadingSvg;